var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vab-icon", {
    staticClass: "fold-unfold",
    style: _vm.classObject,
    attrs: { icon: _vm.collapse ? "menu-line" : "menu-line" },
    on: { click: _vm.toggleCollapse },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }